import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import { insightsDesignEnabled } from "../../common/utils/insightsDesignEnabled";
import "./index.scss";

function isSidebarLinkActive(pathname, to) {
  if (to === "/dashboard") {
    return pathname === "/dashboard" || pathname === "/";
  }
  if (to === "/insights") {
    return pathname === "/insights" || pathname.startsWith("/insights/");
  }
  return pathname === to || pathname.startsWith(`${to}/`);
}

function LegacyListItemLink({ primary, to }) {
  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <li className="drawer-sidebar-link">
      <ListItem button component={renderLink}>
        <ListItemText
          sx={{
            fontWeight: "bold",
          }}
          disableTypography
          primary={primary}
        />
      </ListItem>
    </li>
  );
}

LegacyListItemLink.propTypes = {
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

function DesignListItemLink({ primary, to }) {
  const { pathname } = useLocation();
  const isActive = isSidebarLinkActive(pathname, to);

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <li
      className={
        isActive ? "drawer-sidebar-link drawer-sidebar-link--active" : "drawer-sidebar-link"
      }
    >
      <ListItemButton component={renderLink} sx={{ borderRadius: 0 }}>
        <ListItemText primary={primary} disableTypography />
      </ListItemButton>
    </li>
  );
}

DesignListItemLink.propTypes = {
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default function SideBar() {
  const sideBarLinks = [
    { label: "Dashboard", to: "/dashboard" },
    { label: "Insights", to: "/insights" },
    { label: "Content Library", to: "/recipes-menu" },
    { label: "Collections & Cuisine", to: "/collections-menu" },
    { label: "Smart Videos", to: "/smart-videos" },
    { label: "Barcodes", to: "/barcodes" },
    { label: "Canada Beef Advantage", to: "/cba-menu" },
    { label: "Posters", to: "/posters" },
    { label: "Profile & Settings", to: "/profile" },
  ];

  const insightsDesignIsEnabled = insightsDesignEnabled();
  const ListItemLink = insightsDesignIsEnabled ? DesignListItemLink : LegacyListItemLink;

  return (
    <Box
      className={insightsDesignIsEnabled ? "insights-design-sidebar" : undefined}
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      <List disablePadding={insightsDesignIsEnabled}>
        {sideBarLinks.map((link) => (
          <ListItemLink key={link.label} to={link.to} primary={link.label} />
        ))}
      </List>
    </Box>
  );
}
